var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement, nothing } from 'lit';
import { property, query, queryAssignedElements, state } from 'lit/decorators.js';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-navigation-global.lit.scss';
import styles from './sds-navigation.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
import { classMap } from 'lit/directives/class-map.js';
import { debounce, throttle } from 'lodash-es';
import { HierarchicalSearchService } from './services/hierarchical-search.service';
import { translate } from '../utilities/translate';
/**
 * `sds-navigation` is a component for handling navigation within an application.
 * It includes options for a sidebar, search functionality, and hover state,
 * making it suitable for complex UI layouts that require enhanced navigation.
 *
 * ### Attributes
 * - `sidebar`: Defines the sidebar configuration for the navigation component.
 * - `search`: Toggles the search functionality within the navigation component.
 * - `hovered`: Indicates whether the navigation is in a hovered state.
 *
 * @tag sds-navigation
 */
let SdsNavigation = (() => {
    var _SdsNavigation_sidebar_accessor_storage, _SdsNavigation_withSearch_accessor_storage, _SdsNavigation_hovered_accessor_storage, _SdsNavigation_useNativeNavigation_accessor_storage, _SdsNavigation_expandTrigger_accessor_storage, _SdsNavigation__allNavigationItems_accessor_storage, _SdsNavigation_search_accessor_storage, _SdsNavigation__sidebarItems_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-navigation')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _sidebar_decorators;
    let _sidebar_initializers = [];
    let _sidebar_extraInitializers = [];
    let _withSearch_decorators;
    let _withSearch_initializers = [];
    let _withSearch_extraInitializers = [];
    let _hovered_decorators;
    let _hovered_initializers = [];
    let _hovered_extraInitializers = [];
    let _useNativeNavigation_decorators;
    let _useNativeNavigation_initializers = [];
    let _useNativeNavigation_extraInitializers = [];
    let _expandTrigger_decorators;
    let _expandTrigger_initializers = [];
    let _expandTrigger_extraInitializers = [];
    let __allNavigationItems_decorators;
    let __allNavigationItems_initializers = [];
    let __allNavigationItems_extraInitializers = [];
    let _search_decorators;
    let _search_initializers = [];
    let _search_extraInitializers = [];
    let __sidebarItems_decorators;
    let __sidebarItems_initializers = [];
    let __sidebarItems_extraInitializers = [];
    var SdsNavigation = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this._stylesGlobal = stylesGlobal;
            _SdsNavigation_sidebar_accessor_storage.set(this, __runInitializers(this, _sidebar_initializers, void 0));
            _SdsNavigation_withSearch_accessor_storage.set(this, (__runInitializers(this, _sidebar_extraInitializers), __runInitializers(this, _withSearch_initializers, void 0)));
            _SdsNavigation_hovered_accessor_storage.set(this, (__runInitializers(this, _withSearch_extraInitializers), __runInitializers(this, _hovered_initializers, void 0)));
            _SdsNavigation_useNativeNavigation_accessor_storage.set(this, (__runInitializers(this, _hovered_extraInitializers), __runInitializers(this, _useNativeNavigation_initializers, false)));
            _SdsNavigation_expandTrigger_accessor_storage.set(this, (__runInitializers(this, _useNativeNavigation_extraInitializers), __runInitializers(this, _expandTrigger_initializers, 'icon')));
            _SdsNavigation__allNavigationItems_accessor_storage.set(this, (__runInitializers(this, _expandTrigger_extraInitializers), __runInitializers(this, __allNavigationItems_initializers, [])));
            _SdsNavigation_search_accessor_storage.set(this, (__runInitializers(this, __allNavigationItems_extraInitializers), __runInitializers(this, _search_initializers, void 0)));
            _SdsNavigation__sidebarItems_accessor_storage.set(this, (__runInitializers(this, _search_extraInitializers), __runInitializers(this, __sidebarItems_initializers, void 0)));
            this._hierarchicalSearchItems = __runInitializers(this, __sidebarItems_extraInitializers);
            this.hierarchicalSearchService = new HierarchicalSearchService();
            this.throttledUpdateAllNavigationItems = throttle(() => {
                this.updateAllNavigationItems();
            }, 300);
            this.updateAllNavigationItems = () => {
                this._allNavigationItems = this.getNestedNavigationItems(this._sidebarItems);
                this._hierarchicalSearchItems = Promise.resolve(this._sidebarItems.map(item => SdsNavigation.makeHierarchicalSearchItem(item)));
                // Ensure sidebar properties are updated whenever navigation items are refreshed
                this.updateSidebarProperty(this._allNavigationItems);
                // No need to manually call requestUpdate() - _allNavigationItems is @state() so it's reactive
            };
            this.openSideBar = () => {
                const layout = document.querySelector('sds-layout');
                if (layout && layout.sidebar) {
                    layout.sidebar = 'unfolded';
                    this.debouncedSetFocus();
                }
            };
            this.debouncedSetFocus = debounce(() => {
                this.search.focused = true;
            }, 100);
            this.handleSearchEvent = throttle(async (event) => {
                const searchValue = event.detail.value;
                const items = await this._hierarchicalSearchItems;
                if (searchValue.trim() === '') {
                    this.hierarchicalSearchService.makeAllItemsVisible(items);
                    this.dispatchSearchChangedEvent(searchValue, SdsNavigation.SEARCH_CLEARED_EVENT);
                }
                else {
                    this.hierarchicalSearchService.filterItems(items, searchValue);
                    this.dispatchSearchChangedEvent(searchValue, SdsNavigation.SEARCH_CHANGED_EVENT);
                }
                // Force all navigation items to recalculate heights after search
                this.updateAllNavigationItemHeights();
                this.requestUpdate();
            }, 1000);
        }
        /**
         * Specifies the sidebar configuration for this navigation component.
         *
         * @attr {string} sidebar - The sidebar configuration.
         */
        get sidebar() { return __classPrivateFieldGet(this, _SdsNavigation_sidebar_accessor_storage, "f"); }
        set sidebar(value) { __classPrivateFieldSet(this, _SdsNavigation_sidebar_accessor_storage, value, "f"); }
        /**
         * Enables or disables the search functionality within the navigation.
         * When true, a search option is provided for the user.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} search - If true, the search functionality is enabled.
         */
        get withSearch() { return __classPrivateFieldGet(this, _SdsNavigation_withSearch_accessor_storage, "f"); }
        set withSearch(value) { __classPrivateFieldSet(this, _SdsNavigation_withSearch_accessor_storage, value, "f"); }
        /**
         * Indicates whether the navigation is in a hovered state.
         * Used to style or animate the navigation based on user interaction.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} hovered - If true, the navigation is hovered.
         */
        get hovered() { return __classPrivateFieldGet(this, _SdsNavigation_hovered_accessor_storage, "f"); }
        set hovered(value) { __classPrivateFieldSet(this, _SdsNavigation_hovered_accessor_storage, value, "f"); }
        /**
         * Enables native browser navigation when `href` is set.
         * If true, clicking the item will navigate using the browser's default behavior.
         * If false, custom event-based navigation can be implemented instead.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} native - Enables native browser navigation.
         */
        get useNativeNavigation() { return __classPrivateFieldGet(this, _SdsNavigation_useNativeNavigation_accessor_storage, "f"); }
        set useNativeNavigation(value) { __classPrivateFieldSet(this, _SdsNavigation_useNativeNavigation_accessor_storage, value, "f"); }
        /**
         * Determines the trigger for expanding/collapsing navigation items with children.
         * When set to 'item', clicking anywhere on the item will expand/collapse it.
         * When set to 'icon', only clicking the expand/collapse icon will trigger the action.
         *
         * @attribute expand-trigger
         */
        get expandTrigger() { return __classPrivateFieldGet(this, _SdsNavigation_expandTrigger_accessor_storage, "f"); }
        set expandTrigger(value) { __classPrivateFieldSet(this, _SdsNavigation_expandTrigger_accessor_storage, value, "f"); }
        get _allNavigationItems() { return __classPrivateFieldGet(this, _SdsNavigation__allNavigationItems_accessor_storage, "f"); }
        set _allNavigationItems(value) { __classPrivateFieldSet(this, _SdsNavigation__allNavigationItems_accessor_storage, value, "f"); }
        /**
         * Computed property: whether search should be shown (more than 16 items)
         * @private
         */
        get shouldShowSearch() {
            return this.withSearch && this._allNavigationItems.length > 16;
        }
        get search() { return __classPrivateFieldGet(this, _SdsNavigation_search_accessor_storage, "f"); }
        set search(value) { __classPrivateFieldSet(this, _SdsNavigation_search_accessor_storage, value, "f"); }
        get _sidebarItems() { return __classPrivateFieldGet(this, _SdsNavigation__sidebarItems_accessor_storage, "f"); }
        set _sidebarItems(value) { __classPrivateFieldSet(this, _SdsNavigation__sidebarItems_accessor_storage, value, "f"); }
        connectedCallback() {
            super.connectedCallback();
            this.updateAllNavigationItems();
            appendStylesToTheStyleRoot(this, 'sds-navigation', this._stylesGlobal.cssText);
        }
        firstUpdated() {
            var _a, _b;
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot')) === null || _b === void 0 ? void 0 : _b.addEventListener('slotchange', () => {
                this.updateAllNavigationItems();
                // Update sidebar properties whenever new items are slotted
                this.updateSidebarProperty(this._allNavigationItems);
                this._allNavigationItems.forEach(el => {
                    el.removeEventListener('sds.nav.item.change', this.throttledUpdateAllNavigationItems);
                    el.addEventListener('sds.nav.item.change', this.throttledUpdateAllNavigationItems);
                });
            });
            // Observe for dynamically added navigation items
            this.setupNavigationItemObserver();
            this.updateAllNavigationItems();
            this.updateSidebarProperty(this._allNavigationItems);
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has('sidebar') || changedProperties.has('hovered')) {
                this.updateSidebarProperty(this._allNavigationItems);
            }
        }
        updateSidebarProperty(items) {
            items.forEach(item => {
                if (this.isNavigationItem(item)) {
                    item.sidebar = this.sidebar;
                    item.native = this.useNativeNavigation;
                    item.expandTrigger = this.expandTrigger;
                    item.hovered = this.hovered;
                    const nestedItems = item.querySelectorAll('sds-navigation-item');
                    if (nestedItems.length > 0) {
                        this.updateSidebarProperty(Array.from(nestedItems));
                    }
                }
            });
        }
        setupNavigationItemObserver() {
            // Watch for dynamically added navigation items
            const observer = new MutationObserver(mutations => {
                let hasNewNavigationItems = false;
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const element = node;
                            // Check if the added element is a navigation item or contains navigation items
                            if (element.tagName === 'SDS-NAVIGATION-ITEM' ||
                                element.querySelectorAll('sds-navigation-item').length > 0) {
                                hasNewNavigationItems = true;
                            }
                        }
                    });
                });
                if (hasNewNavigationItems) {
                    // Throttle updates to avoid excessive calls
                    this.throttledUpdateAllNavigationItems();
                }
            });
            // Observe this element and its descendants
            observer.observe(this, {
                childList: true,
                subtree: true,
            });
        }
        isNavigationItem(element) {
            return element.tagName === 'SDS-NAVIGATION-ITEM';
        }
        static makeHierarchicalSearchItem(navItem) {
            return {
                title: navItem.itemTitle,
                children: () => Array.from(navItem.children).map((childNavItem) => SdsNavigation.makeHierarchicalSearchItem(childNavItem)),
                show: () => (navItem.hidden = false),
                hide: () => (navItem.hidden = true),
                expand: () => (navItem.toggle = 'expanded'),
            };
        }
        getNestedNavigationItems(items) {
            const allItems = new Set();
            const recursiveFetch = (elements) => {
                elements.forEach(element => {
                    if (!allItems.has(element)) {
                        allItems.add(element);
                        const nestedItems = Array.from(element.querySelectorAll(':scope > sds-navigation-item'));
                        if (nestedItems.length > 0) {
                            recursiveFetch(nestedItems);
                        }
                    }
                });
            };
            recursiveFetch(items);
            return Array.from(allItems);
        }
        render() {
            return html `
            <div class="${this.getClasses()}" role="navigation">
                <slot name="skip-to-content"></slot>
                ${this.renderMobileLogo()} ${this.renderSearch()}
                <slot></slot>
                <slot name="skip-to-header"></slot>
            </div>
        `;
        }
        renderMobileLogo() {
            if (this.shouldShowSearch) {
                return html ` <slot name="logo"></slot> `;
            }
        }
        renderSearch() {
            if (this.shouldShowSearch) {
                return html `
                <div class="sds-navigation__search" part="sds-main-header-search">
                    <div class="sds-navigation__search-icon" @click="${this.openSideBar}">
                        <sds-icon size="24" name="search"></sds-icon>
                    </div>

                    <sds-search
                        @sds.search.input="${this.handleSearchEvent}"
                        @sds.search.cleared="${this.handleSearchEvent}"
                        class="sds-navigation__search-element"
                        placeholder="${translate('sds.navigation_search.search')}"
                        value
                        in-navigation
                        aria-label="Search navigation items"
                    ></sds-search>
                    ${this._sidebarItems.every(item => item.hidden)
                    ? html ` <div
                              class="sds-navigation__search-empty"
                              role="status"
                              aria-live="polite"
                          >
                              ${translate('sds.navigation.no_items_found')}
                          </div>`
                    : nothing}
                </div>
            `;
            }
        }
        updateAllNavigationItemHeights() {
            // Force all navigation items to recalculate their heights
            this._allNavigationItems.forEach(item => {
                if (this.isNavigationItem(item)) {
                    item.requestUpdate();
                }
            });
        }
        dispatchSearchChangedEvent(searchValue, eventType) {
            const searchEvent = new CustomEvent(eventType, {
                detail: { value: searchValue },
                bubbles: true,
                composed: true,
            });
            this.dispatchEvent(searchEvent);
        }
        getClasses() {
            return classMap({
                'sds-navigation': true,
                'sds-navigation--folded': this.sidebar === 'folded',
            });
        }
    };
    _SdsNavigation_sidebar_accessor_storage = new WeakMap();
    _SdsNavigation_withSearch_accessor_storage = new WeakMap();
    _SdsNavigation_hovered_accessor_storage = new WeakMap();
    _SdsNavigation_useNativeNavigation_accessor_storage = new WeakMap();
    _SdsNavigation_expandTrigger_accessor_storage = new WeakMap();
    _SdsNavigation__allNavigationItems_accessor_storage = new WeakMap();
    _SdsNavigation_search_accessor_storage = new WeakMap();
    _SdsNavigation__sidebarItems_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsNavigation");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _sidebar_decorators = [property({ type: String, reflect: true })];
        _withSearch_decorators = [property({ type: Boolean, attribute: 'with-search' })];
        _hovered_decorators = [property({ type: Boolean })];
        _useNativeNavigation_decorators = [property({ type: Boolean, attribute: 'native' })];
        _expandTrigger_decorators = [property({ type: String, attribute: 'expand-trigger' })];
        __allNavigationItems_decorators = [state()];
        _search_decorators = [query('sds-search')];
        __sidebarItems_decorators = [queryAssignedElements({ flatten: true })];
        __esDecorate(_classThis, null, _sidebar_decorators, { kind: "accessor", name: "sidebar", static: false, private: false, access: { has: obj => "sidebar" in obj, get: obj => obj.sidebar, set: (obj, value) => { obj.sidebar = value; } }, metadata: _metadata }, _sidebar_initializers, _sidebar_extraInitializers);
        __esDecorate(_classThis, null, _withSearch_decorators, { kind: "accessor", name: "withSearch", static: false, private: false, access: { has: obj => "withSearch" in obj, get: obj => obj.withSearch, set: (obj, value) => { obj.withSearch = value; } }, metadata: _metadata }, _withSearch_initializers, _withSearch_extraInitializers);
        __esDecorate(_classThis, null, _hovered_decorators, { kind: "accessor", name: "hovered", static: false, private: false, access: { has: obj => "hovered" in obj, get: obj => obj.hovered, set: (obj, value) => { obj.hovered = value; } }, metadata: _metadata }, _hovered_initializers, _hovered_extraInitializers);
        __esDecorate(_classThis, null, _useNativeNavigation_decorators, { kind: "accessor", name: "useNativeNavigation", static: false, private: false, access: { has: obj => "useNativeNavigation" in obj, get: obj => obj.useNativeNavigation, set: (obj, value) => { obj.useNativeNavigation = value; } }, metadata: _metadata }, _useNativeNavigation_initializers, _useNativeNavigation_extraInitializers);
        __esDecorate(_classThis, null, _expandTrigger_decorators, { kind: "accessor", name: "expandTrigger", static: false, private: false, access: { has: obj => "expandTrigger" in obj, get: obj => obj.expandTrigger, set: (obj, value) => { obj.expandTrigger = value; } }, metadata: _metadata }, _expandTrigger_initializers, _expandTrigger_extraInitializers);
        __esDecorate(_classThis, null, __allNavigationItems_decorators, { kind: "accessor", name: "_allNavigationItems", static: false, private: false, access: { has: obj => "_allNavigationItems" in obj, get: obj => obj._allNavigationItems, set: (obj, value) => { obj._allNavigationItems = value; } }, metadata: _metadata }, __allNavigationItems_initializers, __allNavigationItems_extraInitializers);
        __esDecorate(_classThis, null, _search_decorators, { kind: "accessor", name: "search", static: false, private: false, access: { has: obj => "search" in obj, get: obj => obj.search, set: (obj, value) => { obj.search = value; } }, metadata: _metadata }, _search_initializers, _search_extraInitializers);
        __esDecorate(_classThis, null, __sidebarItems_decorators, { kind: "accessor", name: "_sidebarItems", static: false, private: false, access: { has: obj => "_sidebarItems" in obj, get: obj => obj._sidebarItems, set: (obj, value) => { obj._sidebarItems = value; } }, metadata: _metadata }, __sidebarItems_initializers, __sidebarItems_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsNavigation = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.SEARCH_CHANGED_EVENT = 'sds.search.changed';
    _classThis.SEARCH_CLEARED_EVENT = 'sds.search.cleared';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsNavigation = _classThis;
})();
export { SdsNavigation };
